/* LiberLive App — Song Library rail arrows. Per-instance, cleans up on unload. */
(function () {
  function init(root) {
    if (!root || root.__llaplib) return;
    root.__llaplib = true;
    var rail = root.querySelector('[data-rail]');
    if (!rail) return;
    var arrows = Array.prototype.slice.call(root.querySelectorAll('[data-dir]'));
    function step() {
      var card = rail.querySelector('.llap-song');
      var w = card ? card.getBoundingClientRect().width : 200;
      return (w + 20) * 2;
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      arrows.forEach(function (a) {
        var dir = +a.getAttribute('data-dir');
        if (dir < 0) a.disabled = rail.scrollLeft <= 2;
        else a.disabled = rail.scrollLeft >= max;
      });
    }
    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        rail.scrollBy({ left: (+a.getAttribute('data-dir')) * step(), behavior: 'smooth' });
      });
    });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    root.__llaplibUpdate = update;
    update();
  }
  function boot() { document.querySelectorAll('[data-llap-lib]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-llap-lib]'); if (el) init(el); });
})();
